import React from "react";
import "./Quest.css";
import "./QuestSkeleton.css";

const QuestCardSkeleton = () => {
    return (
        <div className="quest-card-container">
            <div className="quest-card-image-container">
                <div className="quest-card-skeleton-image skeleton-pulse"></div>
            </div>

            <div className="quest-card-text w-100 gap-2">
                <div className="quest-card-skeleton-text skeleton-pulse"></div>
                <div className="quest-card-skeleton-subtext skeleton-pulse"></div>
            </div>
        </div>
    );
};

export default QuestCardSkeleton;
